import { render } from "./FormStepTwo.vue?vue&type=template&id=573c2744"
import script from "./FormStepTwo.vue?vue&type=script&lang=js"
export * from "./FormStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Java Script Udemy Kurs\\VUE COURSE\\vue-form\\vue-form\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__